import { createContext, useContext } from "react"

const SubscriptionContext = createContext({})

export const useSubscriptionContext = () => useContext(SubscriptionContext)

export default SubscriptionContext
